/*@ngInject*/
const RuleBuilderHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, ruleActionsUtil, ruleModel, modalUtil, ruleAction, ruleUtil, umStudioConstant) {

    $element.addClass('ruleBuilderHeader');

    this.rule = null;
    this.translations = null;

    this.actions = [];
    this.context = {
        identifier: 'ruleBuilderHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};

    this.$onInit = function () {
        localization.getTranslationByKey('ruleBuilderHeader').then((translations) => {
            this.rule = ruleModel.getRule($stateParams.ruleId);
            this.translations = translations;
            this.loadActions();
        });
    };

    this.loadActions = function () {
        configurationMediator.loadRuleBuilderActions(`com.firstbest.rules.model.Rule:${$stateParams.ruleId}`).then((actions) => {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });

            this.processActions(allActions, /*enableSaveAndDiscard*/false);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === ruleAction.SAVE) {
                    action.enabled = false;
                    if (ruleModel.hasUnsavedChanges($stateParams.ruleId)) {
                        this.actionSubTexts[action.name] = {
                            class: 'unsavedChanges',
                            text: _.get(this.translations, 'unsavedChanges')
                        };
                        action.enabled = true;
                    }
                }

                if (action.name === ruleAction.DISCARD) {
                    action.enabled = false;
                    if (ruleModel.hasUnsavedChanges($stateParams.ruleId)) {
                        action.enabled = true;
                    }
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    this.getStatus = function () {
        if (!_.isNil(this.rule)) {
            return _.get(this.translations, 'status.' + this.rule.status);
        }
        return '';
    };

    this.getRuleSet = function () {
        return ruleUtil.getRuleSetName(this.rule);
    };

    this.handleAction = function (action, file) {
        if (action.enabled) {
            switch (action.name) {
                case ruleAction.SAVE:
                    ruleActionsUtil.saveRule(this.rule).then(function () {
                        $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
                    });
                    break;

                case ruleAction.DISCARD:
                    ruleActionsUtil.discardChanges();
                    break;

                case ruleAction.DELETE:
                    ruleActionsUtil.delete(this.rule);
                    break;

                case ruleAction.RULE_SETTINGS:
                    $uibModal.open({
                        templateUrl: '/configuration/ruleTemplateSettings/ruleTemplateSettings.tpl.html',
                        controller: 'ruleTemplateSettingsController',
                        windowClass: 'ruleTemplateSettingsModal',
                        resolve: {
                            options: {
                                rule: this.rule
                            }
                        }
                    });
                    break;

                case ruleAction.DEACTIVATE:
                    ruleActionsUtil.deactivateRule(this.rule);
                    break;

                case ruleAction.ACTIVATE:
                    ruleActionsUtil.activateRule(this.rule);
                    break;

                case ruleAction.REDEPLOY:
                    ruleUtil.redeployRuleSets(this.rule.parentId);
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on(configurationConstant.event.RULE_MODEL_UPDATED, (event, ruleId) => {
        if (parseInt($stateParams.ruleId) === ruleId) {
            this.rule = ruleModel.getRule(ruleId);
        }
        this.processActions(this.actions);
    });

    $scope.$on(umStudioConstant.event.RULE_UPDATED, () => {
        this.processActions(this.actions);
    });

    $scope.$on(umStudioConstant.event.RULE_STATUS_UPDATED, () => {
        this.loadActions();
    });

    $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, () => {
        this.processActions(this.actions);
    });

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateRuleBuilder = _.startsWith(fromState.name, 'configuration.ruleBuilder'),
            isTargetSameAsCurrent = toState.name === fromState.name;
        if (toState.name === 'login') {
            return;
        }
        if (ruleModel.hasUnsavedChanges($stateParams.ruleId) && isCurrentStateRuleBuilder && !isTargetSameAsCurrent) {
            event.preventDefault();
            ruleActionsUtil.saveRule(this.rule).then(function () {
                $state.go(toState, toParams);
            });
        }
    });
};

angular.module('ums.configuration')
    .controller('ruleBuilderHeaderController', RuleBuilderHeaderController);
